import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	height: 100%;
	overflow: auto;
`;

export const twoInputs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;
